// Importing Components
import * as DescriptionItems from './DescriptionItems';

// Importing Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Importing styles
import './description.scss';

/**
 * Description Component
 * @param {Object} props - The props object containing items, customClass, and title
 * @param {Array} props.items - Array of items to be displayed in the description
 * @param {string} props.customClass - Custom CSS class for the description container
 * @param {string} props.title - Title of the description
 * @returns {JSX.Element} Description component JSX
 */
const Description = ({ items, customClass, title }) => {
    return items && items.length ? (
        <div className="description-container">
            {title ? <div className="description-title">{title}</div> : <></>}{' '}
            {/* Displaying title if provided */}
            <div className={`description-items-container ${customClass}`}>
                {items.map((item, index) => {
                    const { key, label, children, component } = item;

                    if (component) {
                        // If component property is provided, render corresponding DescriptionItems component
                        return DescriptionItems[component]({ ...item });
                    }
                    return (
                        <div
                            key={`${key}-${index}`}
                            className="description-item"
                        >
                            <div className="label">{label}</div>{' '}
                            {/* Displaying label */}
                            <div className="children">
                                {children ? children : '-'}{' '}
                                {/* Displaying children or default '-' */}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    ) : (
        // If no items provided, return empty fragment
        <></>
    );
};

// PropTypes for Description component
Description.propTypes = {
    items: PropTypes.array,
    customClass: PropTypes.string,
    title: PropTypes.string,
};

export default Description;
